/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A free-text paragraph that explains the insight in prose, used to give context or interpretation between data-heavy blocks.
 */
export interface Narrative { 
    /**
     * Discriminator identifying this block as a narrative paragraph.
     */
    type?: Narrative.TypeEnum;
    /**
     * The narrative copy to display, may contain newlines.
     */
    text: string;
}
export namespace Narrative {
    export const TypeEnum = {
        Narrative: 'narrative'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


